var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
function visit(data, actorEntryPoints, config) {
  var result;
  if (config.compact) {
    result = visitCompact(data, actorEntryPoints, config);
  } else {
    result = visitExpanded(data, actorEntryPoints, config);
  }
  return result;
}
function visitCompact(data, actorEntryPoints, config) {
  actorEntryPoints = actorEntryPoints ? actorEntryPoints : new Map();
  var visitor;
  var prevIndex;
  visitor = [];
  prevIndex = -1;
  // traverse events
  var events = data.events.reduce(function (acc, event, i) {
    if (!event.isHidden) {
      if (i != 0) {
        data.events[prevIndex].remove.forEach(function (a) {
          return visitor = remove(a, visitor);
        });
      }
      event.add.forEach(function (actorID) {
        var actor = data.actors.get(actorID);
        if (!actor.isHidden) {
          var entryPoint = actorEntryPoints.get(actorID);
          if (!entryPoint) {
            var entryPoint_1 = Math.random();
            actorEntryPoints.set(actorID, entryPoint_1);
          }
          visitor = add(actorID, entryPoint, visitor);
        }
      });
      event.switch = group(event.group, visitor);
      event.state = __spreadArrays(visitor);
      acc.push(event);
    }
    prevIndex++;
    return acc;
  }, []);
  return [events, actorEntryPoints];
}
function visitExpanded(data, actorEntryPoints, config) {
  actorEntryPoints = actorEntryPoints ? actorEntryPoints : new Map();
  if (actorEntryPoints.size === 0) {
    data.actors.forEach(function (y) {
      if (!y.isHidden) actorEntryPoints.set(y.actorID, Math.random());
    });
  }
  var visitor;
  var prevIndex;
  visitor = Array.from(actorEntryPoints).sort(function (a, b) {
    return a[1] - b[1];
  }).map(function (y) {
    return y[0];
  });
  // traverse events
  var events = data.events.reduce(function (acc, event, i) {
    if (!event.isHidden) {
      event.switch = group(event.group, visitor);
      event.state = __spreadArrays(visitor);
      acc.push(event);
    }
    prevIndex++;
    return acc;
  }, []);
  return [events, actorEntryPoints];
}
function add(a, gene, visitor) {
  // add the new object at the distance from the center indicated by the entryPoint
  var pos = Math.round(visitor.length * gene - 1);
  visitor.splice(pos, 0, a);
  return visitor;
}
function remove(a, visitor) {
  // a contains the yObj
  return visitor.filter(function (p) {
    return p != a;
  });
}
function switchP(switchActors, visitor) {
  // move the yObj to the group and shift all the others
  var temp = visitor.splice(switchActors.prev, 1);
  visitor.splice.apply(visitor, __spreadArrays([switchActors.target, 0], temp));
  return visitor;
}
function group(group, visitor) {
  // calculate the center
  var center = getCenter(group, visitor);
  // calculate the distance of each yPoint from the mass center
  var dists = getDistances(group, center, visitor);
  // array containing the switch operations
  var switches = [];
  // array describing the outer boundary of the already-adiacent group elements
  var edges = [center, center];
  // looping strategies for backward and forward searching
  var strategies = new Map();
  // first element is the descending edge, the second one the ascending
  strategies.set(1, {
    init: 1,
    comp: function (i) {
      return i < visitor.length;
    }
  });
  strategies.set(-1, {
    init: 0,
    comp: function (i) {
      return i >= 0;
    }
  });
  // Check for every y that has to be grouped if it is adjacent, else switch.
  // Since the distances are sorted for their absolute values, begin grouping
  // from the nearest to the farthest
  dists.forEach(function (p) {
    var direction = -Math.sign(p.distance);
    if (direction != 0) {
      var strategy = strategies.get(direction);
      var index = visitor.indexOf(p.p);
      var _loop_1 = function (i) {
        if (index >= edges[0] && index <= edges[1] || edges[1] === 0 && direction === 1 || edges[0] === visitor.length - 1 && direction === -1) {
          return "break";
        } else if (!dists.some(function (a) {
          return a.p === visitor[i];
        })) {
          // if the visited y is a non-grouped element, then switch it
          // with the current element p
          var switchY = {
            target: i,
            prev: index
          };
          switches.push(switchY);
          switchP(switchY, visitor);
          return "break";
        } else {
          // extend adjacent edges
          edges[strategy.init] += direction;
        }
      };
      for (var i = edges[strategy.init]; strategy.comp(i); i += direction) {
        var state_1 = _loop_1(i);
        if (state_1 === "break") break;
      }
    }
  });
  return switches;
}
function getCenter(group, visitor) {
  return Math.round(visitor.reduce(function (count, y, i) {
    return group.includes(y) ? count + i : count;
  }, 0) / group.length);
}
function getDistances(group, center, visitor) {
  return group.map(function (p) {
    var i = visitor.indexOf(p);
    var distance = center - i;
    return {
      p: p,
      distance: distance
    };
  }).sort(function (a, b) {
    return Math.abs(a.distance) - Math.abs(b.distance);
  });
}
export { visit, add, remove, switchP, group, getCenter, getDistances };